/*
 * @Author: Teemo Ding
 * @Date: 2021-08-04 17:39:14
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-07 10:23:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/Subscriber/index.tsx
 */

import { Button } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { handleOnFormatStoreTimeAndDateWithTimezone } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import css from '../css.module.less';

const permissions = () => {
  const send_account_invite = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.send_account_invite,
      }),
    ],
  });
  return {
    send_account_invite,
  };
};

const Subscriber = ({
  type,
  registeredDate,
  uuid,
  salesChannelName,
  createdDate,
  sendAccountInvite,
  lastInvitation,
  salesChannel,
  createdBy,
  timezoneInGMT,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { send_account_invite } = permissions();
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.subscriber} ${css.wrapperContainer}`}
        title={
          type == 'Subscriber'
            ? getI18n('customerList.customerList.subscriber')
            : getI18n('customerList.subscriber.customerAccount')
        }>
        <div className={css.subscriberItem}>
          <h3>
            {type == 'Subscriber'
              ? getI18n('customerList.subscriber.subscriptionID')
              : getI18n('customerList.subscriber.customerID')}
          </h3>
          <p>{uuid}</p>
        </div>
        {type === 'Subscriber' && (
          <div className={css.subscriberItem}>
            <h3>{getI18n('customerTag.subscription.subscribed')}</h3>
            <p>
              {salesChannel
                ? `${getI18n('customerList.subscriber.subscribedfrom')} ${_.get(
                    salesChannel,
                    'name',
                    '',
                  )}`
                : `${getI18n(
                    'customerList.subscriber.subscribedby',
                  )} ${createdBy}`}
            </p>
            <p>
              {getI18n('customerList.subscriber.subscribedon')} {createdDate}{' '}
              (UTC
              {timezoneInGMT})
            </p>
          </div>
        )}
        {type !== 'Subscriber' && (salesChannelName || registeredDate) && (
          <div className={css.subscriberItem}>
            <h3>{getI18n('customerList.subscriber.accountRegistered')}</h3>
            <p>
              {getI18n('customerList.subscriber.registeredfrom')}{' '}
              {salesChannelName}
            </p>
            <p>
              {getI18n('customerList.subscriber.registeredon')}{' '}
              {handleOnFormatStoreTimeAndDateWithTimezone(registeredDate)} (UTC{' '}
              {timezoneInGMT})
            </p>
          </div>
        )}
        {type !== 'Subscriber' && !salesChannelName && !registeredDate && (
          <div className={css.subscriberItem}>
            <div className={css.subscriberItem}>
              <h3>{getI18n('customerList.subscriber.accountCreated')}</h3>
              <p>
                {getI18n('customerList.subscriber.createdon')}{' '}
                {handleOnFormatStoreTimeAndDateWithTimezone(createdDate)} (UTC{' '}
                {timezoneInGMT})
              </p>
            </div>
          </div>
        )}
        {type !== 'Subscriber' && lastInvitation && (
          <div className={css.subscriberItem}>
            <div className={css.subscriberItem}>
              <h3>{getI18n('customerList.subscriber.accountInviteSent')}</h3>
              <p>
                {replaceI18nVariables(
                  getI18n('customerList.subscriber.invite${type}senton${time}'),
                  _.get(lastInvitation, 'email', '')
                    ? getI18n('general.email')
                    : getI18n('general.mobile'),
                  moment((lastInvitation || {}).lastSent).format(
                    'DD MMM YYYY HH:mm',
                  ),
                )}
              </p>
            </div>
          </div>
        )}
        {type !== 'Subscriber' && !salesChannelName && !registeredDate && (
          <Button
            type='primary'
            onClick={sendAccountInvite}
            disabled={!send_account_invite}>
            {lastInvitation
              ? getI18n('customerList.subscriber.resendAccountInvite')
              : getI18n('customerList.subscriber.sendAccountInvite')}
          </Button>
        )}
      </SectionWrapper>
    </div>
  );
};

export default Subscriber;
